//angular
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
//app
import { AppAnimations } from '../../../_shared/animations';
import { StorageService } from '../../../_core/services';

@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  animations: [AppAnimations],
  host: { '[@slideInRightAnimation]': '', 'class': 'display flex h100vh' }
})

export class VerifyComponent implements OnInit {
  userEmail: string;

  constructor(
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer,
    private _storage: StorageService
  ) {
    this._iconRegistry.addSvgIcon('ico-back', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-back-01.svg'));
    this._iconRegistry.addSvgIcon('ico-verify', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-verify-02.svg'));
    this._iconRegistry.addSvgIcon('logo-rebillia', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/logo-rebillia.svg'));
    this.userEmail = this._storage.readLocalStorage('userEmail');
  }

  ngOnInit() {
  }

}
